// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.encounter.assessment.UpdateMedicalDecisionMakingRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdateMedicalDecisionMakingRequest extends GandalfModelBase {

	@GandalfValidator({ notNull: { message: 'Id must not be null' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	id!: number;

	@GandalfConstantDecorator(constants.MedicalDecisionMakingComplexity)
	@GandalfValidator({ notNull: { message: 'MedicalDecisionMakingComplexity must not be null' } })
	@GandalfProperty({ designType: constants.MedicalDecisionMakingComplexity, isRequired: true })
	medicalDecisionMakingComplexity!: constants.MedicalDecisionMakingComplexity;

	@GandalfConstantDecorator(constants.MedicalDecisionMakingConsultation)
	@GandalfValidator({ notNull: { message: 'MedicalDecisionMakingConsultation must not be null' } })
	@GandalfProperty({ designType: constants.MedicalDecisionMakingConsultation, isRequired: true })
	medicalDecisionMakingConsultation!: constants.MedicalDecisionMakingConsultation;

	@GandalfConstantDecorator(constants.MedicalDecisionMakingNumDx)
	@GandalfValidator({ notNull: { message: 'MedicalDecisionMakingNumDx must not be null' } })
	@GandalfProperty({ designType: constants.MedicalDecisionMakingNumDx, isRequired: true })
	medicalDecisionMakingNumDxLevel!: constants.MedicalDecisionMakingNumDx;

	@GandalfConstantDecorator(constants.MedicalDecisionMakingRisk)
	@GandalfValidator({ notNull: { message: 'MedicalDecisionMakingRisk must not be null' } })
	@GandalfProperty({ designType: constants.MedicalDecisionMakingRisk, isRequired: true })
	medicalDecisionMakingRisk!: constants.MedicalDecisionMakingRisk;

}
